import type { UserDetails } from "@/app/types/domain";

export function getUserDisplayName(userDetails: UserDetails | null | undefined): string {
  return userDetails?.name || userDetails?.fullName || userDetails?.username || "";
}

export function getUserPincode(userDetails: UserDetails | null | undefined): string {
  return userDetails?.pinCode || userDetails?.pincode || "";
}

export function getUserPhone(userDetails: UserDetails | null | undefined): string {
  return userDetails?.phoneNumber || userDetails?.phone || userDetails?.mobile || "";
}

export function getUserGstNumber(userDetails: UserDetails | null | undefined): string {
  return userDetails?.gstNumber || "";
}

export function getUserBankDetails(userDetails: UserDetails | null | undefined): string {
  return userDetails?.bankDetails || "";
}

export function getUserAddress(userDetails: UserDetails | null | undefined): string {
  return userDetails?.address || "";
}

export function getUserCity(userDetails: UserDetails | null | undefined): string {
  return userDetails?.city || "";
}

export function getUserState(userDetails: UserDetails | null | undefined): string {
  return userDetails?.state || "";
}

export function buildNamePatch(value: string): Partial<UserDetails> {
  return { name: value, fullName: value };
}

export function buildAddressPatch(value: string): Partial<UserDetails> {
  return { address: value };
}

export function buildCityPatch(value: string): Partial<UserDetails> {
  return { city: value };
}

export function buildStatePatch(value: string): Partial<UserDetails> {
  return { state: value };
}

export function buildPincodePatch(value: string): Partial<UserDetails> {
  return { pinCode: value, pincode: value };
}

export function buildPhonePatch(value: string): Partial<UserDetails> {
  return { phoneNumber: value, phone: value, mobile: value };
}

export function buildGstPatch(value: string): Partial<UserDetails> {
  return { gstNumber: value };
}

export function buildBankDetailsPatch(value: string): Partial<UserDetails> {
  return { bankDetails: value };
}
